module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/delete-58c45a8089c4f27a79af214b711f5ccb.png";